import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

export default function CTA02() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <section className="py-16 bg-white px-4">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden"
          style={{
            background: '#000000',
            borderRadius: '22px',
            padding: '0',
          }}
        >
          <div
            className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-6"
            style={{ padding: '60px 64px' }}
          >
            {/* Left: text content */}
            <div className="flex-1 text-center md:text-left">
              <h2
                className="text-white font-bold mb-4 leading-tight"
                style={{ fontSize: 'clamp(36px, 5vw, 52px)', fontWeight: 800 }}
              >
                Begin Your Journey
              </h2>
              <p
                className="mb-6"
                style={{
                  color: '#B0B0B0',
                  fontSize: '17px',
                  lineHeight: 1.65,
                  maxWidth: '520px',
                  margin: '0 0 20px',
                }}
              >
                Secure your Australian visa and migration plan with Hola World's expert guidance.
              </p>
              {/* Feature row */}
              <div className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2 mt-5">
                {['Expert Guidance', 'Fast Processing', 'End-to-End Support'].map((item) => (
                  <span key={item} className="flex items-center gap-1.5" style={{ color: '#D1D5DB', fontSize: '14px' }}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <circle cx="8" cy="8" r="8" fill="#ffffff20"/>
                      <path d="M4.5 8.5l2.5 2.5 4.5-5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Decorative curved arrow — hidden on mobile */}
            <div className="hidden md:flex items-center justify-center flex-shrink-0 w-24" aria-hidden="true">
              <svg width="90" height="60" viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 48 C20 48, 30 10, 72 14"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  fill="none"
                  opacity="0.55"
                />
                <path
                  d="M66 8 L74 15 L64 19"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                  opacity="0.55"
                />
              </svg>
            </div>

            {/* Right: CTA button */}
            <div className="flex-shrink-0">
              <button
                onClick={() => {
                  const path = location.pathname;
                  const src = path === '/' ? 'home' : path.replace(/^\//, '').replace(/\//g, '-');
                  navigate('/contact?from=' + encodeURIComponent(src + '-cta-banner'));
                }}
                className="font-semibold transition-all duration-300 hover:scale-105"
                style={{
                  background: '#FFFFFF',
                  color: '#000000',
                  padding: '14px 28px',
                  borderRadius: '10px',
                  fontSize: '15px',
                  fontWeight: 600,
                  border: 'none',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={e => (e.currentTarget.style.background = '#f2f2f2')}
                onMouseLeave={e => (e.currentTarget.style.background = '#FFFFFF')}
              >
                Book Consultation
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
